export default {
  "title": "Bandu Cloud Storage",
  "expand": "Expand storage",
  "intro": "Bandu Cloud Storage stores live photo galleries, event files and other content. Live photos currently use {used}. ",
  "unlimitedPlan": "Your current plan includes unlimited storage.",
  "photoRatio": "This represents {percent}% of total storage.",
  "viewPhotos": "View live photo galleries ›",
  "overview": "📊 Storage overview",
  "capacity": "Total capacity",
  "used": "Used",
  "available": "Available storage",
  "utilization": "Usage",
  "unlimited": "Unlimited",
  "usedAmount": "Used: {amount}",
  "remainingAmount": "Available: {amount}",
  "breakdown": "📁 Storage breakdown",
  "photoNotes": "📷 Live photo storage",
  "photoExplanation": "Original and retouched live photos are stored in Bandu Cloud Storage and linked to their events.",
  "albumUsage": "{count} live photo galleries currently use {used} of storage.",
  "exhausted": "New live photos cannot be uploaded when storage is full. Upgrade your plan in {membership}.",
  "membership": "My membership",
  "photos": "Live photos",
  "activityFiles": "Event files",
  "otherFiles": "Other files",
  "adminTitle": "Bandu Cloud Storage · Platform management",
  "export": "Export details",
  "adminIntro": "Monitor storage usage across the platform. View each organization’s usage, quota and status, and identify organizations that need more space.",
  "platformOverview": "Platform storage overview",
  "reserve": "Platform storage reserve",
  "averageUsage": "Average usage",
  "alerts": "Storage alerts",
  "alertCounts": "Full: {full} / Near limit: {critical}",
  "allocated": "Total allocated quota",
  "reserveUsage": "Platform reserve: {reserve} / Used: {used}",
  "alertBanner": "{count} accounts are using more than {percent}% of their storage, including {full} that are full. Contact them to recommend expanding storage or upgrading their plan.",
  "userDetails": "Account storage usage",
  "search": "Search by name or account",
  "allStatus": "All statuses",
  "full": "Full",
  "critical": "Near limit",
  "normal": "Normal",
  "userAccount": "User / Account",
  "plan": "Plan",
  "serviceTypes": "Services",
  "usedQuota": "Used / Quota",
  "status": "Status",
  "lastActive": "Last active",
  "actions": "Actions",
  "viewDetails": "View details",
  "remind": "Remind",
  "detailTitle": "Storage details ·",
  "usedSpace": "Used storage",
  "quota": "Total quota",
  "remaining": "Available",
  "accountPrefix": "Account: ",
  "planPrefix": "Plan: ",
  "typePrefix": "Type: ",
  "lastActivePrefix": "Last active: ",
  "inactive": "Not activated",
  "close": "Close",
  "remindExpand": "Expansion reminder",
  "personal": "Personal",
  "company": "Organization",
  "unused": "Not in use",
  "reminderBody": "Remind “{name}” to expand cloud storage? In-app and SMS notifications are not available yet. Please contact the organization through another channel.",
  "reminderTitle": "Storage expansion reminder",
  "understood": "Got it",
  "user": "User",
  "account": "Account",
  "type": "Type",
  "usedGb": "Used (GB)",
  "quotaExport": "Quota (GB)",
  "exportFilename": "Cloud_storage_details-{date}.csv",
  "exportSuccess": "Exported {count} entries",
  "photoLiveService": "Live photo galleries",
  "registrationService": "Event registration",
  "eventsService": "Events",
  "allModules": "All modules"
}
